import { Injectable } from '@angular/core';
import { FcsOperation } from '../enums/fcs-operation.enum';
import { ConfigurationService } from './configuration.service';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserInfo } from '../models/user-info';
import { CustomerShort } from '../models/customer-short';
import { CustomerEmployeeShort } from '../models/customer-employee-short';
import { EmployeeService } from './employee.service';
import { OrganizationService } from './organization.service';

/**
 * Сервис контекста - хранит контекст о текущем пользователе.
 */
@Injectable({
  providedIn: 'root'
})
export class ContextService {
  constructor(
    private configuration: ConfigurationService,
    private employeeService: EmployeeService,
    private organizationService: OrganizationService
  ) {
    this.initEmployee();
    this.initOrganization();
  }

  public employee$ = new BehaviorSubject<CustomerEmployeeShort>(null);
  public organization$ = new BehaviorSubject<CustomerShort>(null);

  /** Возвращает сведения о текущем сотруднике. */
  public initEmployee() {
    const user = this.configuration.configuration.user;
    if (!user || !user.employeeId) {
      this.employee$.next(null);
    } else {
      const sub = this.employeeService
        .get(user.employeeId)
        .pipe(filter((value) => !!value))
        .subscribe((result) => {
          this.employee$.next(result);
          sub.unsubscribe();
        });
    }
  }

  /** Возвращает сведения о текущей организации. */
  public initOrganization() {
    const user = this.configuration.configuration.user;
    if (!user || !user.organizationId) {
      this.organization$.next(null);
    } else {
      const sub = this.organizationService
        .get(user.organizationId)
        .pipe(filter((value) => !!value))
        .subscribe((result) => {
          this.organization$.next(result);
          sub.unsubscribe();
        });
    }
  }

  /**
   * Возвращает сведения о текущем пользователе.
   */
  public getUser(): UserInfo {
    return this.configuration.configuration.user;
  }

  /**
   * Возвращает перечень доступных операций.
   */
  public getPermittedOperations(): FcsOperation[] {
    return this.configuration.configuration.user.permittedOperations;
  }
}
